import { render, staticRenderFns } from "./EditPerson.vue?vue&type=template&id=0fe27bb8&scoped=true"
import script from "./EditPerson.vue?vue&type=script&lang=js"
export * from "./EditPerson.vue?vue&type=script&lang=js"
import style0 from "./EditPerson.vue?vue&type=style&index=0&id=0fe27bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe27bb8",
  null
  
)

export default component.exports